import React, { useEffect } from 'react'
import { Backdrop, Box, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

import SplashImg from 'assets/splash.png'
import { useAppContext } from 'context/AppContext'
import './SplashScreen.scss'

const SplashScreen: React.FC = () => {
  const { showSplashScreen, setShowSplashScreen } = useAppContext()

  useEffect(() => {
    if (showSplashScreen) {
      const timeout = setTimeout(() => {
        setShowSplashScreen(false)
      }, 4000)

      return () => clearTimeout(timeout)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showSplashScreen])

  return (
    <Backdrop
      open={showSplashScreen}
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#190f27',
      }}
    >
      <Box
        sx={{
          p: 2,
          height: '100%',
          width: '100%',
        }}
      >
        <IconButton
          onClick={() => setShowSplashScreen(false)}
          sx={{
            position: 'absolute',
            top: 0,
            right: 0,
            color: '#fff',
            cursor: 'pointer',
            zIndex: 20,
          }}
        >
          <CloseIcon />
        </IconButton>

        <Box
          sx={{
            height: '57vh',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
          }}
        >
          <div className="SplashScreen__image-bg"></div>
          <Box
            component="img"
            src={SplashImg}
            alt="splash image"
            sx={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              zIndex: 10,
            }}
          />
        </Box>

        <div className="SplashScreen__invite">Join the Gekko Cult NOW!</div>

        <div className="SplashScreen__info ">
          RampMeDaddy, your ultimate Telegram memecoin wallet, is almost here!
          While you wait, play our game, rack up points and secure early access
          to reap the early adopter benefits.
        </div>
      </Box>
    </Backdrop>
  )
}

export default SplashScreen
